import moment from 'moment'
import {
  getHotelTypes,
  getHotelAmenities,
  getHotelThemes,
  getRoomAmenities,
  getSearchParams,
  getSearchResults,
  search
} from 'b2b-common/services/api/hotel'
import { sortByHotDeal } from 'b2b-common/utils/hotel/sorting'

export default {
  initDataLoaded: false,

  sortMethod: sortByHotDeal,

  hotelTypes: [],
  hotelAmenities: [],
  hotelThemes: [],
  roomAmenities: [],

  distribution: null,

  params: {
    rooms: [{ adults: 2, ages: [] }],
    countryName: '',
    resortName: '',
    checkIn: '',
    checkOut: ''
  },
  results: [],
  fees: {},

  getDuration () {
    return moment(this.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(this.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
  },

  getNoRooms () {
    return this.params.rooms.length
  },

  getNoAdults () {
    return this.params.rooms.reduce((acc, room) => acc + room.adults, 0)
  },

  getNoChildren () {
    return this.params.rooms.reduce((acc, room) => acc + room.ages.length, 0)
  },

  getNoPax () {
    return this.getNoAdults() + this.getNoChildren()
  },

  generateFees () {
    const fees = {}
    for (let i = 5; i >= 0; i--) {
      fees[i] = {
        percent: 0,
        value: 0
      }
    }
    return fees
  },

  saveFees () {
    localStorage.setItem('hotelFees', JSON.stringify(this.fees))
  },

  async init () {
    if (this.initDataLoaded) return Promise.resolve(true)
    const initialRequests = {
      params: getSearchParams({ dc: this.distribution }),
      results: getSearchResults({ dc: this.distribution }),
      hotelAmenities: getHotelAmenities(),
      roomAmenities: getRoomAmenities(),
      hotelThemes: getHotelThemes(),
      hotelTypes: getHotelTypes()
    }
    const res = await Promise.all(Object.values(initialRequests))
    const data = {}
    for (let i = 0; i < Object.keys(initialRequests).length; i++) {
      data[Object.keys(initialRequests)[i]] = res[i]
    }
    this.params = data.params
    this.results = data.results
    this.hotelAmenities = data.hotelAmenities
    this.roomAmenities = data.roomAmenities
    this.hotelThemes = data.hotelThemes
    this.hotelTypes = data.hotelTypes
    const hotelFees = localStorage.getItem('hotelFees')
    if (hotelFees) this.fees = JSON.parse(hotelFees)
    else this.fees = this.generateFees()
    this.initDataLoaded = true
    return true
  },

  sort ({ sortMethod = this.sort }) {
    this.sortMethod = sortMethod
    this.results = this.results.sort(this.sortMethod)
  },

  async search (params) {
    const res = await search({ ...params })
    const newParams = await getSearchParams({ dc: this.distribution })
    this.params = newParams
    this.results = res
    this.sort({ sortMethod: this.sortMethod })
    return this.results
  }

}
